import { cn } from "@/lib/utils";
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import { RaisyLogoLoader } from "@/components/loading/RaisyLogoLoader";

const spinnerVariants = cva("flex-col items-center justify-center", {
  variants: {
    show: {
      true: "flex",
      false: "hidden",
    },
  },
  defaultVariants: {
    show: true,
  },
});

const SIZE_MAP: Record<string, number> = {
  small: 20,
  medium: 32,
  large: 48,
};

interface SpinnerContentProps
  extends VariantProps<typeof spinnerVariants> {
  size?: "small" | "medium" | "large";
  className?: string;
}

/**
 * Animated spinner component for loading states.
 */
export function Spinner({ size = "medium", show, className }: SpinnerContentProps) {
  return (
    <span className={cn(spinnerVariants({ show }), className)}>
      <RaisyLogoLoader
        size={SIZE_MAP[size] ?? SIZE_MAP.medium}
        color="#0ab3bf"
        speed={1.17}
        stroke={5}
        strokeLength={0.2}
        bgOpacity={0.15}
      />
    </span>
  );
}
